module.exports = __webpack_public_path__ + "assets/images/e11cb8bf1a2374699d1d918efff8827f.jpg";